
import { Profile } from "../types";
import { ContactInfoSection } from "./ContactInfoSection";
import { IdCardsSection } from "./IdCardsSection";
import { PaymentsSection } from "./PaymentsSection";
import { ClaimsSection } from "./ClaimsSection";
import { ContactActions } from "./actions/ContactActions";

interface SectionsContainerProps {
  profile: Profile;
  sectionVisibility: Record<string, boolean>;
  toggleSectionVisibility: (sectionName: string) => void;
}

export const SectionsContainer = ({
  profile,
  sectionVisibility,
  toggleSectionVisibility,
}: SectionsContainerProps) => {
  return (
    <div className="space-y-6">
      <ContactInfoSection 
        profile={profile}
        isVisible={sectionVisibility["contact_info"] ?? true}
        onToggle={toggleSectionVisibility}
        sectionVisibility={sectionVisibility}
        toggleSectionVisibility={toggleSectionVisibility}
      />

      <IdCardsSection 
        contactId={profile.id}
        isVisible={sectionVisibility["id_cards"] ?? true}
        onToggle={toggleSectionVisibility}
      />

      <PaymentsSection contactId={profile.id} />

      <ClaimsSection 
        contactId={profile.id}
        isVisible={sectionVisibility["claims"] ?? true}
        onToggle={toggleSectionVisibility}
      />

      <ContactActions profile={profile} />
    </div>
  );
};
